/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { Loader } from '@googlemaps/js-api-loader';

import { environment } from '@env/environment';

import {
  GmapsMap,
  GmapsMarker,
  GmapsPolygon,
  GmapsPolyline,
  GmapsPosition,
} from '../../models/gmaps.model';

declare const google: any;

@Component({
  selector: 'bkg-gmaps',
  templateUrl: './gmaps.component.html',
})
export class GmapsComponent implements OnInit {
  @Input() mapConfig: GmapsMap;
  @ViewChild('map') mapRef: ElementRef;

  map: any;

  ngOnInit(): void {
    const loader = new Loader({
      apiKey: environment.maps_apiKey,
    });
    loader.load().then(() => {
      this.loadMap();
    });
  }

  private loadMap(): void {
    this.map = new google.maps.Map(this.mapRef.nativeElement, {
      center: this.convertLatLng(this.mapConfig.position),
      zoom: this.mapConfig.zoom,
      styles: [
        {
          featureType: "poi.business",
          stylers: [{ visibility: "off" }],
        },
      ],
    });
    this.mapConfig?.markers?.forEach((marker: GmapsMarker) => {
      marker.position = this.convertLatLng(marker.position);
      this.addMarker(marker);
    });
    this.mapConfig?.polygons?.forEach((polygon: GmapsPolygon) => {
      this.addPolygon(polygon);
    });
    this.mapConfig?.polylines?.forEach((polyline: GmapsPolyline) => {
      this.addPolyline(polyline);
    });
    this.resizeMap();
  }



  private addMarker(marker: any): void {
    const markerIcon = {
      url: marker.icon,
      scaledSize: new google.maps.Size(40, 40),
    };
    marker.icon = markerIcon;
    const mapMarker = new google.maps.Marker(marker);

    mapMarker.setMap(this.map);
  }

  private addPolygon(polygon: GmapsPolygon): void {
    const mapPolygon = new google.maps.Polygon(polygon);

    mapPolygon.setMap(this.map);
  }

  private addPolyline(polyline: GmapsPolyline): void {
    const mapPolygon = new google.maps.Polyline({
      ...polyline,
      clickable: false,
    });

    mapPolygon.setMap(this.map);
  }

  private resizeMap(): void {
    google.maps.event.trigger(this.map, 'resize');
  }

  private convertLatLng(position: GmapsPosition): GmapsPosition {
    return {
      lat: Number(position.lat),
      lng: Number(position.lng),
    };
  }
}
